import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Currencies, WalletTypes } from '@constants/enums';
import { selectBusiness } from '@pages/profile/store/selectors';
import { selectWalletsData } from '@/modules/wallets/selectors';
import { UseCurrencySelectorReturn } from '../types/useCurrencySelector.types';

export const useCurrencySelector = (): UseCurrencySelectorReturn => {
  const { t } = useTranslation();
  const walletData = useSelector(selectWalletsData);
  const { businessName } = useSelector(selectBusiness) || {
    businessName: 'EFEX',
  };

  const filteredWallets =
    walletData?.filter((wallet) => wallet.currency.name !== Currencies.COP) ||
    [];

  const globalAccounts = filteredWallets.filter(
    (wallet) => wallet.wallet.wallet_type === WalletTypes.GLOBAL_ACCOUNT
  );

  const loanAccounts = filteredWallets.filter(
    (wallet) => wallet.wallet.wallet_type === WalletTypes.LOAN_ACCOUNT
  );

  const translations = {
    selectorTitle: t('afnSelectorTitle'),
    globalAccountTitle: t('afnGlobalAccount'),
    loanAccountTitle: t('afnLoanAccount'),
    globalAccountTooltip: t('afnGlobalAccountTooltip', { businessName }),
    loanAccountTooltip: t('afnLoanAccountTooltip', { businessName }),
    getCurrencyName: (currencyName: string): string => t(`w${currencyName}`),
  };

  const findDefaultWalletUuid = (
    defaultCurrency: Currencies = Currencies.USD,
    walletType?: WalletTypes
  ): string => {
    const walletCollections = {
      [WalletTypes.GLOBAL_ACCOUNT]: globalAccounts,
      [WalletTypes.LOAN_ACCOUNT]: loanAccounts,
      default: [...globalAccounts, ...loanAccounts],
    };

    const walletsToSearch = walletType
      ? walletCollections[walletType] || loanAccounts
      : walletCollections.default;

    const wallet = walletsToSearch.find(
      (w) => w.currency.name === defaultCurrency
    );
    return wallet?.uuid || globalAccounts[0]?.uuid || '';
  };

  return {
    findDefaultWalletUuid,
    globalAccounts,
    loanAccounts,
    translations,
  };
};

export default useCurrencySelector;
